import { render, staticRenderFns } from "./commonFooter.vue?vue&type=template&id=8ef578b4&scoped=true"
import script from "./commonFooter.vue?vue&type=script&lang=js"
export * from "./commonFooter.vue?vue&type=script&lang=js"
import style0 from "./commonFooter.vue?vue&type=style&index=0&id=8ef578b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef578b4",
  null
  
)

export default component.exports